



































































































































































































































































































































































































































import {
  defineComponent,
  SetupContext,
  computed,
  PropType,
  useRouter,
  useRoute,
  useContext,
  watch,
  reactive,
  inject,
  Ref,
} from '@nuxtjs/composition-api';
import useAppRoute from '@/compositions/useAppRoute';
import { useAppStore } from '~/store/app';
import {
  useUserNoticeQuery,
  useNewNoticeSubscription,
} from '~/graphql/graphqlOperations';
import {
  UnreadStatus,
  UnreadStatusKey,
  useUnread,
} from '~/compositions/useUnread';
type DirectionType = 'row' | 'column';
export default defineComponent({
  props: {
    direction: {
      type: String as PropType<DirectionType>,
      default: 'row',
    },
  },
  setup(props, context: SetupContext) {
    const { URLs } = useAppRoute();

    const ctx = useContext();
    const router = useRouter();
    const route = useRoute();

    // サインイン済みかどうかをstoreから取得する
    const { store } = useAppStore();

    // console.warn('💫💫💫💫 MenuBar 💫💫💫💫');
    // console.warn(router);
    // console.warn(route);
    // console.warn(URLs.show_portfolio_with_id());
    // console.warn(URLs.show_portfolio_with_id('aaa'));
    // console.warn(URLs.show_portfolio_with_id(999));
    // console.warn(URLs.show_corporation_member_with_member_id());
    // console.warn(URLs.show_corporation_member_with_member_id('aaa'));
    // console.warn(URLs.show_corporation_members_with_id());

    // const hidden_urls = [
    //   URLs.edit_profile_base,
    //   URLs.edit_profile_pr,
    //   URLs.new_portfolio,
    //   URLs.portfolio_edit(),
    //   URLs.show_portfolio_with_id(),
    //   URLs.show_aptitude_diagnosis_with_id(),
    //   URLs.new_aptitude_diagnosis,
    //   URLs.show_aptitude_diagnosis_self_result,
    //   URLs.show_recruit_info_with_id(),
    //   URLs.show_seminar_with_id(),
    //   URLs.show_internship_with_id(),
    //   URLs.show_jobs_search,
    //   URLs.show_jobs_search_internship,
    //   URLs.show_jobs_search_seminar,
    //   URLs.show_entry_job_with_id(),
    //   URLs.show_entry_internship_with_id(),
    //   URLs.show_entry_seminar_with_id(),
    //   URLs.show_offer_with_id(),
    // ];

    // console.warn(hidden_urls);
    // console.warn(router?.currentRoute.matched.map((obj) => obj.path));
    // console.warn(route.value.matched.map((obj) => obj.path));

    // console.warn('💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫');
    // console.warn(
    //   route.value.matched
    //     .map((obj) => obj.path)
    //     .some((val) => {
    //       // console.warn(`val=${val}`)
    //       return hidden_urls.includes(val);
    //     })
    // );
    // console.log(props.direction);
    // 指定された引数のパスが現在のURLに含まれるかどうか判定する
    const pathMatch = computed(() => (...paths: string[]) => {
      return paths.some((path) => {
        // パス文字列が空文字のときはサイトのindexルートとみなして特殊処理
        if (!path) {
          return router.currentRoute.path === '/';
        }

        // TODO: 今はただのincludes()で処理しておくけど、もしかしたら、
        //       正規表現判定が必要になるかもしれない
        //       /\/[^/]*/.exec(router.currentRoute.path); ← みたいな
        return router.currentRoute.path.includes(path);
      });
    });

    // サインイン済みかどうか
    const is_siginin = computed(() => {
      return store.isSignedIn;
    });

    const is_visible = computed(() => {
      // TODO: メッセージのスマホサイズの時の例外処理、
      //       正直統一感ないからやりたくない。
      if (route.value.path === URLs.show_messages) {
        return true;
      }

      if (
        route.value.matched
          .map((obj) => obj.path)
          .some((val) => [URLs.show_message_with_id()].includes(val)) &&
        // @ts-ignore
        context.root.$mq === 'sm'
      ) {
        return false;
      }

      return !route.value.matched
        .map((obj) => obj.path)
        .some((val) =>
          [
            URLs.edit_profile_base,
            URLs.edit_profile_pr,
            URLs.new_portfolio,
            URLs.portfolio_edit(),
            URLs.show_portfolio_with_id(),
            URLs.show_aptitude_diagnosis_with_id(),
            URLs.new_aptitude_diagnosis,
            URLs.show_aptitude_diagnosis_self_result,
            URLs.show_recruit_info_with_id(),
            URLs.show_seminar_with_id(),
            URLs.show_internship_with_id(),
            URLs.show_jobs_search,
            URLs.show_jobs_search_internship,
            URLs.show_jobs_search_seminar,
            URLs.show_entry_job_with_id(),
            URLs.show_entry_internship_with_id(),
            URLs.show_entry_seminar_with_id(),
            URLs.show_offer_with_id(),
            URLs.new_activities,
            // URLs.show_message_with_id(),
          ].includes(val)
        );
      // return true;
    });

    // TODO: 多言語の動作確認のために作ったメソッドだから後で消すと思う、めちゃテキトー実装
    const langToggle = () => {
      const now_lang = context.root.$i18n.locale;
      const now_path = context.root.$route.path;

      if (now_lang === 'ja') {
        router.push('/en' + now_path);
      } else {
        router.push(now_path.replace('/en', ''));
      }
    };

    // SSRはとりあえず置いておくとして、ホスト名がdev.で始まっていたら言語切替アイコンを表示しない様にする
    const is_debug = computed(
      () =>
        process.client &&
        !window.location.host.startsWith('dev.') &&
        ctx.$config.ENV === 'development'
    );

    const sysImageUrl = require('~/assets/images/logo.svg');

    // ユーザ未読情報取得
    const unread_status_notification = inject(UnreadStatusKey);
    // const unread_status_notification = inject<Ref<UnreadStatus>>(UnreadStatusKey);

    const user = computed(() => (store ? store.user : null));
    // 学校が公認校かつベーシックプラン以上でない場合は掲示板の新着通知に含めない
    const shouldIncludeNoticeBoard = computed(() => {
      return user.value?.school?.official && user.value?.school?.isBasicPlanOrMore;
    });
    const computedNoticeBoardCount = computed(() => {
      return shouldIncludeNoticeBoard.value ? unread_status_notification?.notice_board : 0;
    });

    return {
      unread_status_notification,
      computedNoticeBoardCount,
      is_visible,
      sysImageUrl,
      is_debug,
      URLs,
      pathMatch,
      langToggle,
      is_siginin,
    };
  },
});
